import { sendReorderWSMessage } from "./dragAndDrop";

// After a reopen succeeds, notify the driver app(s) for each route the backend reports as changed,
// reusing the live-route-adjustment relay path: the same {type:"route_reorder"} signal that drag/reorder
// sends over the shared WS `client`. The driver app (fojw-dwa) refetches the route and reflects the reopen
// (stop un-greys; a finished route that was reopened becomes active again).
//
// `routes` is the reopen endpoints' response body (List<RouteModel>), so only the routes the backend
// actually reopened are notified. No-ops safely when the relay isn't connected (sendReorderWSMessage
// guards on `client`).
export const notifyDriversOfReopenedRoutes = (routes = []) =>
  (routes || []).forEach(route => route && sendReorderWSMessage(route.id));
